module.exports = __webpack_public_path__ + "static/media/contextual-tile-icon.33c3b771.svg";